import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AbstractPolyShapeService } from '../abstract-polyshape.service';
import { TrainingLineHelper } from './training-line-helper';

@Injectable()
export class TrainingLineService extends AbstractPolyShapeService<TrainingLineHelper> {
  protected override shapeStore = this.renderStore('trainingShapes')('lines');

  constructor() {
    super();
    this.setUpSubscriptions();
  }

  protected override setUpSubscriptions() {
    this.subscribeTo(
      combineLatest([this.shapeStore.$, this.renderStore('frameNumber').$]),
      ([shapes, frameNumber]) => {
        this.updateShapes(shapes, frameNumber);
      },
    );
  }

  protected override createHelper(index: number) {
    return new TrainingLineHelper(index);
  }
}
